// export const API_URL = 'https://api.mirror.edunixsystem.com/'
// export const API_URL = 'https://api.motherland.edunixsystem.com/'
// export const API_URL = 'https://api.albayan-schools.com/'
// export const API_URL = 'https://api.rowadalmustakbal.edunixsystem.com/'
export const API_URL = 'https://api.shamsalassil.edunixsystem.com/'
